import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import MenuApi from '../../api/menu';
import { MENU_MUTATIONS_NAME } from './name';
import { TMenuStoreState } from './types';

export async function getMenu(context: ActionContext<TMenuStoreState, unknown>) {
  const response = await MenuApi.getMenuTree();
  context.commit(getLocalState(MENU_MUTATIONS_NAME.setMenu), response);
}
